import { NavigationGuard } from 'vue-router';

import { usePermissions } from 'SharedDir/common/composables/usePermissions';

const DENIED_ROUTE = '/not-found-error';

/**
 * Navigation guard: все переданные разрешения обязательны (strict).
 */
export function requirePermissions(...permissions: Array<string | string[]>): NavigationGuard {
  return (_to, _from, next) => {
    const { can } = usePermissions();
    if (!can(...permissions)) {
      next(DENIED_ROUTE);
      return;
    }
    next();
  };
}

/**
 * Navigation guard: достаточно любого из переданных разрешений.
 */
export function requireAnyPermissions(...permissions: Array<string | string[]>): NavigationGuard {
  return (_to, _from, next) => {
    const { canAny } = usePermissions();
    if (!canAny(...permissions)) {
      next(DENIED_ROUTE);
      return;
    }
    next();
  };
}
